import React, { createContext, useContext } from 'react';

/** Sidebar presentation only; controller forms and their actions remain conversation content. */
export const WorkflowConversationPresentation = createContext<{ minimal: boolean; action?: React.ReactNode }>({ minimal: false });
export function WorkflowConversationAction() {
  return <>{useContext(WorkflowConversationPresentation).action}</>;
}
